import { useEffect, useState, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Volume2, VolumeX } from "lucide-react";
import { Link } from "react-router-dom";

const VIDEO_URL = "https://customer-assets.emergentagent.com/job_store-flow-78/artifacts/cwfy1deh_Make_a_Cat_Promotional_video_f%20%281%29.mp4";
const SEEN_KEY = "mcl_welcome_seen";

export const WelcomeVideo = () => {
  const [open, setOpen] = useState(false);
  const [muted, setMuted] = useState(true);
  const videoRef = useRef(null);

  useEffect(() => {
    if (!sessionStorage.getItem(SEEN_KEY)) {
      const t = setTimeout(() => setOpen(true), 700);
      return () => clearTimeout(t);
    }
  }, []);

  const close = () => {
    sessionStorage.setItem(SEEN_KEY, "1");
    if (videoRef.current) videoRef.current.pause();
    setOpen(false);
  };

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !videoRef.current.muted;
      setMuted(videoRef.current.muted);
    }
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm"
          onClick={close}
          data-testid="welcome-video-overlay"
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0, y: 20 }} animate={{ scale: 1, opacity: 1, y: 0 }} exit={{ scale: 0.92, opacity: 0 }}
            transition={{ type: "spring", damping: 22, stiffness: 240 }}
            className="relative w-full max-w-3xl bg-white rounded-3xl overflow-hidden shadow-2xl"
            onClick={(e) => e.stopPropagation()}
            data-testid="welcome-video-modal"
          >
            <button onClick={close} data-testid="welcome-video-close"
              className="absolute top-4 right-4 z-10 w-10 h-10 rounded-full bg-white/90 hover:bg-white text-[#0F0F0F] flex items-center justify-center shadow-lg transition-colors">
              <X className="w-5 h-5" strokeWidth={2.5} />
            </button>

            <div className="relative bg-black">
              <video
                ref={videoRef}
                src={VIDEO_URL}
                autoPlay
                muted={muted}
                loop
                playsInline
                className="w-full max-h-[70vh] object-contain bg-black"
                data-testid="welcome-video-player"
              />
              <button onClick={toggleMute} data-testid="welcome-video-mute"
                className="absolute bottom-4 left-4 w-11 h-11 rounded-full bg-black/50 hover:bg-black/70 text-white flex items-center justify-center transition-colors">
                {muted ? <VolumeX className="w-5 h-5" /> : <Volume2 className="w-5 h-5" />}
              </button>
            </div>

            <div className="p-6 text-center">
              <h2 className="font-display font-black text-2xl md:text-3xl tracking-tight mb-1">Welcome to Meow Care Love 🐾</h2>
              <p className="text-gray-500 mb-5 text-sm md:text-base">Only the best for our loves — trusted, vet-reviewed care for senior cats.</p>
              <div className="flex flex-wrap gap-3 justify-center">
                <Link to="/shop" onClick={close} data-testid="welcome-video-shop"
                  className="rounded-full bg-[#FF5C28] text-white font-bold px-8 py-3.5 hover:bg-[#E04D1E] transition-colors shadow-lg shadow-[#FF5C28]/25">
                  Shop Collections
                </Link>
                <button onClick={close} data-testid="welcome-video-continue"
                  className="rounded-full bg-white text-[#0F0F0F] font-bold px-8 py-3.5 border-2 border-gray-200 hover:border-[#FF5C28] transition-colors">
                  Continue browsing
                </button>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
